import styled from 'styled-components';
import { getFontSize } from './../../utils/getFont';

export const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(3px);
  background-color: rgba(0, 0, 0, 0.25);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  position: relative;
  background-color: var(--background-soft);
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 90%;
  height: 94%;
  max-width: 500px;
  text-align: center;

  display: flex;
  flex-direction: column;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  h2 {
    font-family: var(--text-cursive);
    ${getFontSize(9)}
    margin: 40px 0 0;
  }
`;

export const CloseButton = styled.button`
  cursor: pointer;
  z-index: 1010;
  background: none;
  border: none;

  svg {
    position: absolute;
    top: 12px;
    right: 12px;

    path {
      fill: var(--text) !important;
      &:hover {
        fill: var(--text) !important;
      }
    }
  }
`;

export const DisplayResults = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  > div {
    display: flex;
    align-items: center;
    border-bottom: 1px solid var(--text-muted);
    padding: 8px 0;
  }

  > div:first-child {
    padding-top: 0;
  }

  > div:last-child {
    border-bottom: none;
  }

  > div img {
    margin-right: 12px;
  }

  > div div {
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
  }

  @media (max-width: 470px) {
    > div img {
      width: 50px;
      height: 50px;
    }
  }
`;
